import { render, staticRenderFns } from "./Personalreport.vue?vue&type=template&id=41a27242&scoped=true"
import script from "./Personalreport.vue?vue&type=script&lang=js"
export * from "./Personalreport.vue?vue&type=script&lang=js"
import style0 from "./Personalreport.vue?vue&type=style&index=0&id=41a27242&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a27242",
  null
  
)

export default component.exports